/* Included for pollyfills. See rolldown.app.ts - the useBuiltIns options */

import 'core-js';
import {Browser} from 'Browser/Browser';
import { User } from 'Browser/User';


window.useVite = false;

const browser = new Browser(window.build,window.site,User.fromJson(window.user));
browser.run().catch(err => log.error(err));

